import React from 'react';
import { Landmark, FileText, DollarSign } from 'lucide-react';

/**
 * Компонент секции долгосрочных обязательств для формы расчета ликвидности
 */
const LongTermLiabilitiesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  // Расчет итоговой суммы долгосрочных обязательств
  const totalLongTermLiabilities = Object.values(formData.longTermLiabilities)
    .reduce((sum, value) => sum + (parseFloat(String(value).replace(/\s+/g, '').replace(',', '.')) || 0), 0);

  return (
    <div className="mb-6 bg-orange-50 dark:bg-orange-900/20 p-5 rounded-lg border border-orange-200 dark:border-orange-800">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Landmark className="w-5 h-5 mr-2 text-orange-500" />
        Долгосрочные обязательства
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Долгосрочные заемные средства */}
        <div>
          <label htmlFor="longTermLiabilities.longTermLoans" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <DollarSign className="w-4 h-4 mr-1.5 text-orange-500" />
            Долгосрочные заемные средства
          </label>
          <input
            type="text"
            id="longTermLiabilities.longTermLoans"
            name="longTermLiabilities.longTermLoans"
            value={formData.longTermLiabilities.longTermLoans}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['longTermLiabilities.longTermLoans'] ? 'input-error' : ''}`}
            placeholder="0"
          />
          {errors['longTermLiabilities.longTermLoans'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['longTermLiabilities.longTermLoans']}
            </p>
          )}
        </div>

        {/* Прочие долгосрочные обязательства */}
        <div>
          <label htmlFor="longTermLiabilities.otherLongTermLiabilities" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <FileText className="w-4 h-4 mr-1.5 text-orange-500" />
            Прочие долгосрочные обязательства
          </label>
          <input
            type="text"
            id="longTermLiabilities.otherLongTermLiabilities"
            name="longTermLiabilities.otherLongTermLiabilities"
            value={formData.longTermLiabilities.otherLongTermLiabilities}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['longTermLiabilities.otherLongTermLiabilities'] ? 'input-error' : ''}`}
            placeholder="0"
          />
          {errors['longTermLiabilities.otherLongTermLiabilities'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['longTermLiabilities.otherLongTermLiabilities']}
            </p>
          )}
        </div>
      </div>

      {/* Итоговая сумма */}
      <div className="mt-4 pt-4 border-t border-orange-200 dark:border-orange-700">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            Всего долгосрочных обязательств:
          </span>
          <span className="text-lg font-semibold text-orange-700 dark:text-orange-300">
            {totalLongTermLiabilities.toLocaleString('ru-RU')} ₽
          </span>
        </div>
      </div>

      {/* Информационная подсказка */}
      <div className="mt-4 bg-orange-100 dark:bg-orange-900/40 p-3 rounded-lg border border-orange-200 dark:border-orange-800">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <FileText className="h-5 w-5 text-orange-600 dark:text-orange-400" />
          </div>
          <div className="ml-3">
            <h4 className="text-sm font-medium text-orange-800 dark:text-orange-200">
              Что включать в долгосрочные обязательства
            </h4>
            <p className="mt-1 text-xs text-orange-700 dark:text-orange-300">
              К долгосрочным обязательствам согласно РСБУ относятся: долгосрочные кредиты и займы (со сроком погашения более 12 месяцев), отложенные налоговые обязательства, оценочные обязательства и прочие долгосрочные обязательства.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LongTermLiabilitiesSection;